<template>
  <header>
    <h1>Hielera Los Hermanos</h1>
  </header>
</template>

<script>
export default {
  name: 'AppHeader'
}
</script>
